export default __webpack_public_path__ + "static/media/burde-sadananda-kamath.02c6d992.jpg";